import { render, staticRenderFns } from "./DialogAdjuntosCliente.vue?vue&type=template&id=4082b7bf&scoped=true"
import script from "./DialogAdjuntosCliente.vue?vue&type=script&lang=js"
export * from "./DialogAdjuntosCliente.vue?vue&type=script&lang=js"
import style0 from "./DialogAdjuntosCliente.vue?vue&type=style&index=0&id=4082b7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4082b7bf",
  null
  
)

export default component.exports